// register.js — entry del bundle dash-v3 (F2.3): Cruscotto v3 React, flag-gated.
// EAGER nel manifest, DOPO dash-v2-register (l'update presuppone l'entry 'dash'
// già registrata v1 e aggiornata v2 — i defer eseguono in ordine di documento).
// Tutta la logica di guardia vive in install.js (testata sotto node);
// qui SOLO il side-effect browser + l'aggancio della factory React.
import { installDashV3 } from './install.js';
import { createDashV3 } from './Cruscotto.jsx';

if (typeof window !== 'undefined') installDashV3(window, createDashV3);
